import {styled as linariaStyled} from '@linaria/react';
import React from 'react';
import sc from 'styled-components';
import {ImageType} from '../../../types/Image';
import {BrandLogo} from '../../atoms/BrandLogo/BrandLogo';
import {Text} from '../../atoms/Text/Text';

export interface BrandTileCompactProps {
  ['data-testid']?: string;
  image?: ImageType;
  brandName: string;
  isSelected: boolean;
}

export const BrandTileCompact: React.FC<BrandTileCompactProps> = ({
  'data-testid': dataTestId,
  image,
  brandName,
  isSelected,
}) => {
  return (
    <Wrapper data-testid={dataTestId} data-is-selected={isSelected}>
      <StyledBrandLogo
        maxHeight="40px"
        image={image}
        name={brandName}
        showTooltip={false}
      />
      <BrandName color="White" size="px10" weight="w500" transform="uppercase">
        {brandName}
      </BrandName>
    </Wrapper>
  );
};

const Wrapper = sc.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  height: 40px;
  padding-inline: 13px;
`;

const StyledBrandLogo = linariaStyled(BrandLogo)`
  width: 32px;
`;

const BrandName = sc(Text)`
  white-space: nowrap;
  letter-spacing: 0.4px;
`;
